import { HomeType } from "@covertree/agent-portal-graphql";

export const mapHomeType = (homeType?: HomeType | null) => {
  switch (homeType) {
    case HomeType.AccessoryDwellingUnit:
      return "Accessory dwelling unit";
    case HomeType.DoubleWide:
      return "Double wide";
    case HomeType.Modular:
      return "Modular";
    case HomeType.Duplex:
      return "Duplex";
    case HomeType.CrossMod:
      return "CrossMod";
    case HomeType.ParkModel:
      return "Park model";
    case HomeType.SelfStorageSecured:
      return "Self storage secured";
    case HomeType.SelfStorageUnSecured:
      return "Self storage unsecured";
    case HomeType.SingleWide:
      return "Single wide";
    case HomeType.StationaryTravelTrailer:
      return "Stationary travel trailer";
    case HomeType.TinyHome:
      return "Tiny home";
    case HomeType.TripleWide:
      return "Triple wide";
    default:
      return "N/A";
  }
};
